// Client/SSR-helpers om content op te halen via /api/_content.
// Bedoeld voor gebruik binnen useAsyncData op de contentpagina's.

export interface ContentDoc {
  id: string
  path: string
  stem: string
  title: string
  description: string
  body: { type: 'root', children: unknown[] }
  seo?: Record<string, unknown>
  schemaOrg?: Record<string, unknown>[]
  head?: Record<string, unknown>
  category?: string
  brokerType?: string
  pagetype?: string
  readingMins?: number
  updatedAt?: string
  [key: string]: unknown
}

export interface NieuwsEntry {
  id: string
  path: string
  title: string
  description: string
  date: string | null
  category: string | null
}

export interface TipEntry {
  path: string
  title: string
  description: string
  category: string | null
  updatedAt: string | null
  readingMins: number | null
}

export const fetchTips = () =>
  $fetch<TipEntry[]>('/api/_content', { query: { tips: 'list' } })

export const fetchContentDoc = (path: string) =>
  $fetch<ContentDoc | null>('/api/_content', { query: { path } })

export const fetchNieuws = () =>
  $fetch<NieuwsEntry[]>('/api/_content', { query: { nieuws: 'list' } })

export const fetchNieuwsSurroundings = (path: string) =>
  $fetch<(NieuwsEntry | null)[]>('/api/_content', { query: { nieuws: 'surround', path } })
